import React, { useState } from "react";
import "./booking.css";

function Booking() {
  const services = [
    "Medical Advisory & Applied Psychology",
    "Medico Legal & Medical Ethics",
    "Digital Health Accessories Wellness & Sports Biomechanics Solutions",
    "Biomedical Engineering & Sports Biomechanics Advisory",
    "AI Health Informatics CSR Health Services",
  ];

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    time: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "94771199190"; // Replace with your WhatsApp number

    const message = `
*NEW APPOINTMENT*

Full Name: ${formData.fullName}
Email: ${formData.email}
Phone: ${formData.phone}

🩺 Service:
${formData.service}

Date: ${formData.date}
Time: ${formData.time}

Message:
${formData.message}
    `;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");

    setFormData({
      fullName: "",
      email: "",
      phone: "",
      service: "",
      date: "",
      time: "",
      message: "",
    });
  };

  return (
    <>
    <div className="booking-page">
      <div className="booking-overlay">
        <div className="booking-container">

          {/* LEFT SIDE */}
          <div className="booking-left">

            <span className="booking-tag">
              BOOK APPOINTMENT
            </span>

            <h1>
             
            </h1>

            <p>
              Schedule your appointment with medical advisory, our healthcare,
              biomedical Engineering, AI health informatics, and
              medico-legal advisory specialists.
            </p>

            <div className="booking-services">
              {services.map((service, index) => (
                <div className="service-card" key={index}>
                  <span className="service-icon">●</span>
                  <p>{service}</p>
                </div>
              ))}
            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="booking-right">

            <form className="booking-form" onSubmit={handleSubmit}>

              <h2>Book an Appointment</h2>

              <div className="form-group">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    Select Service
                  </option>

                  {services.map((service, index) => (
                    <option key={index} value={service}>
                      {service}
                    </option>
                  ))}
                </select>
              </div>

              <div className="double-fields">

                <div className="form-group">
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="time"
                    name="time"
                    value={formData.time}
                    onChange={handleChange}
                    required
                  />
                </div>

              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Additional Message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="booking-btn">
                Book An Appointment
              </button>

            </form>

          </div>

        </div>
      </div>



      
    </div>


 {/* BANK DETAILS */}
<div className="bank-details-card">

  <h3>Bank Details</h3>

  <div className="bank-detail-item">
   
    <p> <span>Account Name</span>Dr. B. Jerish Neeraj</p>
  </div>

  <div className="bank-detail-item">
   
    <p> <span>Company</span>Dr. Jery Medico (Pvt) Ltd</p>
  </div>

  <div className="bank-detail-item">
  
    <p>  <span>Bank :</span>BOC</p>
  </div>

  <div className="bank-detail-item">

    <p><span>Branch :</span>Wellawatta, Colombo 06</p>
  </div>

  <div className="bank-detail-item">
    
    <p className="account-number"><span>Account Number :</span> 95272789</p>
  </div>

</div>
  </>
  );
}

export default Booking;